import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import PublicHeader, { PublicFooter } from "@/components/PublicHeader";

export default function PublicProductOutline() {
  const { pid } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/public/catalog/${pid}`).then((r) => setProduct(r.data)).catch(() => setNotFound(true));
  }, [pid]);

  if (notFound) return (
    <div className="app-root"><PublicHeader />
      <div className="app-main"><div className="loading">That course isn't available yet.</div></div>
      <PublicFooter />
    </div>
  );
  if (!product) return <div className="loading">Loading the course…</div>;

  const startPath = (rid) => navigate(`/login?next=${encodeURIComponent(`/${pid}/${rid}`)}`);

  return (
    <div className="app-root">
      <PublicHeader crumbLabel={product.name} />
      <div className="app-main">
        <section className="page" data-testid="preview-page">
          <div className="container">
            <div className="eyebrow-accent" style={{ marginBottom: "16px" }}>{product.tag} · Course outline</div>
            <h1 className="page-title" style={{ maxWidth: "760px" }}>{product.headline}</h1>
            <p className="page-sub">{product.sub}</p>
            <button className="btn btn--dark" style={{ marginBottom: "40px" }} onClick={() => navigate(`/login?next=${encodeURIComponent(`/${pid}`)}`)} data-testid="preview-signin">
              Sign in to start
            </button>

            <div style={{ display: "grid", gap: "var(--grid-gap)" }} data-testid="preview-roles">
              {product.roles.map((r) => (
                <div key={r.id} className="card card-pad" data-testid={`preview-role-${r.id}`}>
                  <div className="eyebrow">{r.kicker}</div>
                  <div style={{ display: "flex", alignItems: "baseline", gap: "12px", flexWrap: "wrap", margin: "10px 0 6px" }}>
                    <span style={{ fontSize: "var(--fs-card-title-lg)", fontWeight: "var(--fw-extrabold)", letterSpacing: "-0.015em" }}>{r.name}</span>
                    <span className="chip chip--neutral">{r.hours}</span>
                    <span className="chip chip--neutral">{r.moduleCount} modules</span>
                    <span className="chip chip--essential">{r.essentialCount} essential</span>
                  </div>
                  <p className="rcard__blurb" style={{ maxWidth: "640px" }}>{r.blurb}</p>

                  <div className="outline">
                    {r.sections.map((s, si) => (
                      <div key={s.id} className="outline__row" data-testid={`preview-section-${s.id}`}>
                        <span className="scard__num">{String(si + 1).padStart(2, "0")}</span>
                        <span className="outline__title">{s.title}</span>
                        {s.essential && <span className="etag">Essential</span>}
                        <span className="outline__meta">{s.moduleCount} modules · {s.minutes}</span>
                      </div>
                    ))}
                  </div>

                  <button className="link-accent" style={{ marginTop: "16px" }} onClick={() => startPath(r.id)} data-testid={`preview-start-${r.id}`}>
                    Sign in to start the {r.name} path →
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
      <PublicFooter />
    </div>
  );
}
